import { render } from "./VideoScene.vue?vue&type=template&id=57074161&scoped=true"
import script from "./VideoScene.vue?vue&type=script&lang=js"
export * from "./VideoScene.vue?vue&type=script&lang=js"

import "./VideoScene.vue?vue&type=style&index=0&id=57074161&scoped=true&lang=css"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57074161"]])

export default __exports__